import { render, staticRenderFns } from "./import-charge-template-modal.vue?vue&type=template&id=38c71692&scoped=true&"
import script from "./import-charge-template-modal.vue?vue&type=script&lang=js&"
export * from "./import-charge-template-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c71692",
  null
  
)

export default component.exports